import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { SettlementFormFooter } from '@euler/app/flows/task/pages/quotation/components/SettlementFormFooter';
import { SettlementFormView } from '@euler/app/flows/task/pages/quotation/components/SettlementFormView';
import { usePrintQuotationForm } from '@euler/app/flows/task/pages/quotation/functions/usePrintQuotationForm';
import { useQuotationNavigation } from '@euler/app/flows/task/pages/quotation/functions/useQuotationNavigation';
import { useAlert } from '@euler/functions/ux/useAlert';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { SettlementForm } from '@euler/model/task-detail';
import { useServiceFactory } from '@euler/services/factory';
import { useCallback, useEffect, useState } from 'react';

export const SettlementFormPage = wrapNavigatorScreen(
  (_: {
    animationEnabled?: boolean;
    animationTypeForReplace?: 'pop' | 'push';
  }) => {
    const { taskNo, detail } = useTaskContext();
    const [form, setForm] = useState<SettlementForm>();
    const { taskService } = useServiceFactory();
    const alert = useAlert();
    const navigation = useQuotationNavigation();

    useEffect(() => {
      taskService
        .getSettlementForm(taskNo)
        .then(resp => setForm(resp.response))
        .catch(err => {
          void alert({
            title: '获取维修结算单失败',
            message: (err as any).message,
          });
        });
    }, [alert, taskNo, taskService]);

    const onViewQuotationForm = useCallback(() => {
      navigation.push('_main', { editable: false });
    }, [navigation]);

    const onPrint = usePrintQuotationForm(detail.basicInfo.orderNo, {
      type: 'settlement-form',
      showPrice: true,
    });

    if (form == null) {
      return null;
    }

    return (
      <>
        <SettlementFormView form={form} />
        <SettlementFormFooter
          form={form}
          onPrint={onPrint}
          onViewQuotationForm={onViewQuotationForm}
        />
      </>
    );
  },
  params => ({
    title: '维修结算单',
    animationEnabled: params.route.params?.animationEnabled,
    animationTypeForReplace: params.route.params?.animationTypeForReplace,
  }),
);
